/**
 * Splits text by the double-comma separator (",, ") used in the backend
 * to delimit multi-line question text and topics.
 */
export function splitTextBySeparator(text: string): string[] {
  return text.split(',, ');
}
